module.exports = __webpack_public_path__ + "static/media/comment-dots.53709f37.svg";